import { useContext, useMemo } from 'react';
import styled from '@emotion/styled';
import { AuthorContext, ChatSettingsToggleContext } from '@trinity/chat-components/components/Chat';
import { RateLimitingContext } from '@trinity/chat-components/containers/RateLimiting/Context';
import { useToggle } from '@trinity/chat-components/hooks/useToggle';

type Props = {
  children: React.ReactNode;
};

export const ChatSettingsContainer = (props: Props) => {
  return (
    <ChatSettingsToggleContext.Provider value={useToggle()}>
      {props.children}
    </ChatSettingsToggleContext.Provider>
  );
};

export const ChatSettings = () => {
  const ctx = useContext(RateLimitingContext);
  const [, toggle] = useContext(ChatSettingsToggleContext);
  const user = useContext(AuthorContext);

  const stats = useMemo(() => {
    const rawLimit = ctx.query?.data?.limit;
    // If limit is 0 (from empty string coercion), treat it as 5000
    const limit = rawLimit === 0 ? 5000 : (rawLimit ?? null);

    return {
      chats: {
        current: ctx.query?.data?.current ?? 0,
        limit,
      },
    };
  }, [ctx.query?.data]);

  return (
    <Root>
      <Header>
        <Back onClick={toggle}>{`< Back`}</Back>
      </Header>
      <Wrap>
        <Main>
          <Title>Chat Settings</Title>
          <Row>{`Username: ${user.profile.email}`}</Row>
          {stats.chats.limit !== null && (
            <Row>{`Submitted Chats: ${stats.chats.current.toLocaleString()} / ${stats.chats.limit.toLocaleString()}`}</Row>
          )}
          {/* <Row>{`Uploaded Documents: ${stats.documents.total.toLocaleString()} / ${stats.documents.limit.toLocaleString()}`}</Row> */}
        </Main>
      </Wrap>
    </Root>
  );
};

ChatSettings.displayName = 'Chat.Settings';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 85%;
  width: calc(100% - 40px);
  border: 1px solid var(--sec-01);
  border-radius: 6px;
  background-color: var(--pri-01);
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
`;

const Title = styled.div`
  font-size: 22px;
  font-family: var(--font-bold);
`;

const Row = styled.div`
  font-size: 15px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  width: calc(100% - 40px);
`;

const Back = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.palette.wl?.primary?.main ?? 'var(--pri-02)'};
  font-size: 14px;
  font-family: var(--font-semibold);
`;
